import { render } from "./AdminMenuComponent.vue?vue&type=template&id=b2b0879a&scoped=true"
import script from "./AdminMenuComponent.vue?vue&type=script&lang=js"
export * from "./AdminMenuComponent.vue?vue&type=script&lang=js"

import "./AdminMenuComponent.vue?vue&type=style&index=0&id=b2b0879a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b0879a"]])

export default __exports__